import * as React from "react";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import type {StyleType} from "@khanacademy/wonder-blocks-core";
import {
    PhosphorIcon,
    type PhosphorIconAsset,
} from "@khanacademy/wonder-blocks-icon";
import {color} from "@khanacademy/wonder-blocks-tokens";

import copyIcon from "@phosphor-icons/core/regular/copy.svg";

type Props = {
    clipboardText: () => string | any;
    style?: StyleType;
    icon?: PhosphorIconAsset;
    iconColor?: string;
};

export const CopyToClipboardButton = (props: Props): React.ReactElement => {
    return (
        <Clickable
            onClick={() => {
                const value = props.clipboardText();
                if (value) {
                    navigator.clipboard.writeText(value);
                }
            }}
            style={props.style}
        >
            {() => (
                <PhosphorIcon
                    size="medium"
                    icon={props.icon ?? copyIcon}
                    color={props.iconColor ?? color.blue}
                />
            )}
        </Clickable>
    );
};
